export default __webpack_public_path__ + "static/media/m.appointment.09795cfe.png";